<div class="row d-flex justify-content-center align-items-center mt-5">
	<div class="card col-12 col-md-6 shadow">
		<div class="card-body">
			<ng-container *ngIf="!appointmentConfirmed; else confirmedView">
				<h5 class="card-title text-center mb-5 theme-main-color">
					Prise de RDV Prescripteur
				</h5>
				<!-- Formulaire Prescripteur -->
				<form #form="ngForm">
					<!-- Sélection de créneau -->
					<div class="container">
						<div *ngFor="let week of weeks; let weekIndex = index">
							<div
								class="row d-flex justify-content-center align-items-center mt-1"
							>
								<div class="card col-12 shadow">
									<div class="card-body">
										<h5 class="card-title text-center mb-5 theme-main-color">
											Semaine {{ getWeekNumber(weekIndex) }}
										</h5>
										<div class="row">
											<div class="col" *ngFor="let daySlots of week">
												<h6 class="font-weight-bold">
													{{ daySlots.day }} ({{ daySlots.date }})
												</h6>
												<ul
													class="list-group"
													*ngIf="
														daySlots.slots.length > 0;
														else noSlotsAvailable
													"
												>
													<li
														class="list-group-item"
														*ngFor="let slot of daySlots.slots"
													>
														<input
															type="radio"
															id="week-{{ weekIndex }}-day-{{
																daySlots.day
															}}-slot-{{ slot.startTime }}"
															name="slot"
															[value]="slot"
															(change)="onSlotSelected(slot, daySlots.date)"
														/>
														<label
															class="ml-2"
															for="week-{{ weekIndex }}-day-{{
																daySlots.day
															}}-slot-{{ slot.startTime }}"
															>{{ formatTime(slot.startTime) }} -
															{{ formatTime(slot.endTime) }}</label
														>
													</li>
												</ul>
												<ng-template #noSlotsAvailable>
													<div class="text-muted">
														Aucun créneau disponible pour ce jour.
													</div>
												</ng-template>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div
							class="row d-flex justify-content-center align-items-center mt-5"
						>
							<div class="col-auto">
								<button
									class="btn theme-main-color-full-button"
									(click)="addWeek()"
								>
									Semaine suivante <br /><i class="bi bi-arrow-down"></i>
								</button>
							</div>
						</div>
					</div>

					<div class="d-flex justify-content-end mt-4">
						<button
							type="submit"
							class="btn theme-main-color-button"
							[disabled]="!form.valid || !selectedSlot"
							(click)="submitForm()"
						>
							Valider le RDV
						</button>
					</div>
				</form>
			</ng-container>
			<ng-template #confirmedView>
				<div *ngIf="confirmedAppointment; else errorView">
					<h5 class="card-title text-center mb-5 theme-main-color">
						RDV Enregistré
					</h5>
					<p>Date : {{ confirmedAppointment.date | date : 'fullDate' }}</p>
					<p>
						Heure : {{ formatTime(confirmedAppointment.startTime) }} -
						{{ formatTime(confirmedAppointment.endTime) }}
					</p>
					<p>Un email de confirmation a été envoyé à votre adresse.</p>
					<p>
						Vous pouvez rejoindre la réunion en ligne en utilisant le lien
						suivant :
						<a [href]="confirmedAppointment.meetingLink" target="_blank"
							>Rejoindre la réunion</a
						>
					</p>
				</div>
				<ng-template #errorView>
					<div class="alert alert-danger">{{ errorMessage }}</div>
				</ng-template>
			</ng-template>
		</div>
	</div>
</div>
